@if (message.active) {
  <main
      [class.opacity-0]="message.hide"
      [class.opacity-100]="!message.hide"
      class="transition-opacity duration-700 fixed inset-0 z-50 flex items-center justify-center p-4 bg-gray-800/40 overscroll-none">

    <section
        role="dialog"
        aria-modal="true"
        aria-labelledby="error-modal-title"
        [attr.aria-describedby]="message.errorObject.body ? 'error-modal-description' : null"
        class="z-50 flex flex-col w-full max-w-md max-h-full overflow-hidden rounded-xl border border-transparent bg-white shadow-2xl dark:border-biz-gray-900 dark:bg-biz-gray-800">

      <div class="flex-auto min-h-0 overflow-y-auto overscroll-contain p-6 pb-0">
        <div
            id="error-modal-title"
            class="h5 font-semibold leading-tight"
            [innerHTML]="message.errorObject.title">
        </div>
        @if (message.errorObject.body) {
          <div
            id="error-modal-description"
            class="mt-4 text-sm [&_strong]:block [&_strong_p]:mt-1 [&_strong_p]:mb-4 [&_strong_p:last-child]:mb-0 [&_strong_p]:text-xs [&_strong_p]:leading-normal"
            [innerHTML]="message.errorObject.body">
          </div>
        }

        @for (errorLine of message.errorObject.errorLines; track errorLine.title) {
          <InfoCard
              [titleKey]="errorLine.title"
              [bodyKey]="errorLine.body"></InfoCard>
        }
      </div>

      <!--button
          class="absolute bg-transparent text-4xl leading-none right-0 top-0 py-2 px-3 outline-none focus:outline-none hidden md:block"
          (click)="hideMessage()">
        <span [style.color]="appColor ? appColor : '#FF8000'">×</span>
      </button-->

      @if (message.errorObject.buttonAction) {
        <footer class="flex flex-none flex-col items-end gap-1 p-6 pt-4">
          <div class="flex justify-end">
            <BizcuitButton
                [outline]="false"
                [disabled]="processing"
                class="[&_button]:!text-biz-red-500"
                (click)="buttonClicked()">
              {{ message.errorObject.buttonText }}
            </BizcuitButton>
          </div>
          @if (message.errorObject.secondaryButtonAction) {
            <div class="flex justify-end">
              <BizcuitButton
                  class="dark:[&_button]:!text-white"
                  [outline]="false"
                  [disabled]="processing"
                  [color]="appColor ? appColor : '#FF8000'"
                  (click)="secondaryButtonClicked()">
                {{ message.errorObject.secondaryButtonText }}
              </BizcuitButton>
            </div>
          }
        </footer>
      }
    </section>
  </main>
}
